/* eslint-disable */
import Helper from '../util/Helper';

'use strict';
export default {
    init() {
        // JavaScript to be fired on all pages
        var $body = $('body'),
            $navbarStack = $('#stack-navigation'),
            navBreakpoint = $navbarStack.data('breakpoint'),
            $headerBtn = $('header.header .btn-action'),
            fixedOffset = $('header.header').length ? $('header.header').offset().top : 0,
            fixedClass = 'fixed',
            classOpen = 'open',
            classNavOpen = 'nav-open',
            classNavCollapsed = 'nav-collapsed',
            headerHeight = $('header.header').length ? $('header.header').outerHeight() : 0;

        $('a[href*="#"]').click(function (e) {
            if (Helper.checkLocation(this)) {
                let $target = $(this.hash);
                if (this.hash.length && $target.length) {
                    e.preventDefault();
                    Helper.smoothScroll($target, headerHeight + 15);
                }
            }
        });

        if (window.addEventListener) {
            window.addEventListener('load', () => {
                if (location.hash && location.hash !== '#') {
                    let anchorLocation = decodeURIComponent(location.hash),
                        anchorElement = document.querySelector(anchorLocation);
                    if (anchorElement && anchorElement.offsetTop) {
                        setTimeout(() => anchorElement.scrollIntoView(), 100);
                    }
                }
            }, false);
        }

        /* Start Navigation*/
        // Stack menu
        $navbarStack.find('.nav-item.level-0.has-children .top-link').on('click', function (e) {
            let $parent = $(this).parent('li'),
                $submenu = $(this).next('.sub-menu.depth-1');
            if (!Helper.smallScreenHelper(navBreakpoint)) {
                e.preventDefault();
                if (!$('body').hasClass(classNavOpen + '-primary')) {
                    $('body').addClass(classNavOpen + '-primary');
                    $parent.addClass(classOpen);
                    $submenu.stop(true, true).slideDown(200);
                } else {
                    if (!$navbarStack.hasClass(classNavCollapsed)) {
                        closeStackMenu();
                    }
                }

            } else {
                if (!$navbarStack.hasClass(classNavCollapsed)) {
                    $parent.addClass(classOpen);
                }
            }
        });
        if ($headerBtn.length && $('.nav-cta').length <= 0) {
            if (Helper.smallScreenHelper(Helper.lgBreakpoint)) {
                $('<li>').addClass('nav-cta').prependTo($('#primary-menu')).html($headerBtn.clone());
            } else if ($('.nav-cta').length) {
                $('.nav-cta').remove();
            }
        }

        $navbarStack.find('.nav-item .next').on('click', function (e) {
            e.preventDefault();
            let $navItem = $(this).closest('.nav-item'),
                $stack = $navItem.find('.stack').first();
            $stack.addClass('show');
            $navbarStack.find('.open .back').data('current', $stack.data('depth'));
        });

        $navbarStack.find('.nav-item .back').on('click', function (e) {
            e.preventDefault();
            let $navItem = $(this).closest('.nav-item'),
                $stack = $navItem.find('.stack.depth-' + $(this).data('current')).first();
            $stack.removeClass('show');
        });

        $('body').click(function (e) {
            if (!Helper.smallScreenHelper(Helper.lgBreakpoint) && !$(e.target).closest('#stack-menu a').length && !$(e.target).parents('#stack-menu .open').length && !$(e.target).parents('#stack-menu .back').length && !$(e.target).closest('.navbar-toggler').length) {
                closeStackMenu();
            }
        });

        copyCtaBtn();
        movePageHeaderTitles();
        initStackMenu();
        $(window).resize(function () {
            copyCtaBtn();
            movePageHeaderTitles();
            initStackMenu();
        });

        $('.navbar-toggler').on('click', function (e) {
            e.preventDefault();
            $(this.dataset.target).toggleClass('show');
            $('body').toggleClass(classNavOpen + '-primary');
        });

        $(document).scroll(function () {
            let scrollPosition = $(window).scrollTop()
            // store threshold for later use
            if (typeof window.stickyThreshold === 'undefined') {
                window.stickyThreshold = fixedOffset;
            }
            if (scrollPosition > window.stickyThreshold) {
                $body.addClass(fixedClass);
            } else {
                $body.removeClass(fixedClass);
            }
        });

        function initStackMenu() {
            if (Helper.smallScreenHelper(navBreakpoint)) {
                if (!$navbarStack.hasClass(classNavCollapsed)) {
                    $navbarStack.addClass(classNavCollapsed + ' init-collapsed');
                }
            } else {
                if ($navbarStack.hasClass('init-collapsed')) {
                    $navbarStack.removeClass(classNavCollapsed);
                }
            }
        }

        /**
         * Move page header titles
         */
        function movePageHeaderTitles() {
            let $pageHeaderTitles = $('.page-header .titles');
            if ($pageHeaderTitles.length) {
                if (Helper.smallScreenHelper(Helper.xsBreakpoint)) {
                    $('.page-header .titles').addClass('col').insertBefore('.page-header .page-header-content');
                } else {
                    $('.page-header .titles').removeClass('col').prependTo('.page-header .page-header-content');
                }
            }
        }

        /**
         * Copy CTA button to mobile menu
         */
        function copyCtaBtn() {
            if ($headerBtn.length) {
                if (Helper.smallScreenHelper(Helper.lgBreakpoint)) {
                    if ($('.nav-cta').length <= 0) {
                        $('<li>').addClass('nav-cta').prependTo($('#primary-menu')).html($headerBtn.clone());
                    }
                } else if ($('.nav-cta').length) {
                    $('.nav-cta').remove();
                }
            }
        }

        function closeStackMenu() {
            if (!$navbarStack.hasClass(classNavCollapsed) && $navbarStack.find('.sub-menu.depth-1:visible').length) {
                $navbarStack.find('.sub-menu.depth-1:visible').slideUp(200);
                $navbarStack.find('.nav-item.level-0.has-children').removeClass('open');
                if ($navbarStack.find('.sub-menu.show').length) {
                    $navbarStack.find('.sub-menu.show').removeClass('show');
                }
            }
            $('body').removeClass(classNavOpen + '-primary');
            $navbarStack.find('#stack-menu').removeClass('show');
        }

        /* End Navigation*/

        // Smooth scroll for table of contents
        $('.table-contents a').on('click', function (e) {
            e.preventDefault();
            let $target = $(this.hash);
            Helper.smoothScroll($target);
        });

        /* Start Slider */
        var defaultSliderSettings = {
                arrows: true,
                dots: true,
                infinite: false,
                autoplay: false,
                slidesToShow: 4,
                responsive: [
                    {
                        breakpoint: Helper.lgBreakpoint,
                        settings: {
                            slidesToShow: 2,
                            infinite: false,
                        },
                    },
                    {
                        breakpoint: Helper.mdBreakpoint,
                        settings: {
                            slidesToShow: 2,
                            variableWidth: true,
                            infinite: false,
                        },
                    },
                    {
                        breakpoint: Helper.xsBreakpoint,
                        settings: {
                            slidesToShow: 1,
                            variableWidth: false,
                            infinite: false,
                        },
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            variableWidth: false,
                            infinite: false,
                        },
                    },
                ],
            },
            mobileSliderSettings = {
                arrows: true,
                dots: true,
                infinite: false,
                autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                cssEase: 'linear',
                responsive: [
                    {
                        breakpoint: Helper.mdBreakpoint,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: Helper.xsBreakpoint,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                    {
                        breakpoint: Helper.lgBreakpoint,
                        settings: 'unslick',
                    },
                ],
            },
            maxDots = 8;
        $('.slider').on('init', function (e, slick) {
            let element = e.currentTarget;
            if ($(element).find('.slick-arrow').length && $(element).find('.slick-dots').length) {
                let dotWrapperClass = slick.slideCount > maxDots ? ' d-none d-md-block' : '';
                $(element).find('.slick-dots').wrap('<div class="slick-controls"></div>');
                $(element).find('.slick-prev').insertBefore($(element).find('.slick-dots'));
                $(element).find('.slick-next').insertAfter($(element).find('.slick-dots'));
                $(element).find('.slick-dots').wrap('<div class="slick-dots-container' + dotWrapperClass + '"></div>');
                $(element).find('ul.slick-dots li').each(function (index) {
                    $(this).addClass('dot-index-' + index);
                });
            }
        });
        $('.slider.slider-mobile').slick(mobileSliderSettings);
        $('.slider:not(.slider-mobile):not(.col-posts):not(.slick-initialized)').slick(defaultSliderSettings);

        // unslick if slider has less than 4 slides on desktop
        if (!Helper.smallScreenHelper(Helper.lgBreakpoint)) {
            $('.block-slider:not(.block-authors) .slider:not(.slider-mobile).slick-initialized').each(function (i, element) {
                if ($(element).find('.slick-slide').length > 0 && $(element).find('.slick-slide').length < 4) {
                    $(element).slick('unslick');
                }
            });
        }
        /* End Slider */


    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js